import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: ReactNode;
}

export default function Portal({ children }: PortalProps) {
  const [el, setEl] = useState<HTMLDivElement | null>(null);
  useEffect(() => {
    const node = document.createElement('div');
    document.body.appendChild(node);
    setEl(node);
    return () => {
      document.body.removeChild(node);
    };
  }, []);
  if (!el) return null;
  return createPortal(children, el);
}
